module.exports = __webpack_public_path__ + "img/clara-luciani-juin-2021.c17c7fb8.jpg";